import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoAmex16 = t0 => {
  const $ = _c(5);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g><path fillRule="evenodd" clipRule="evenodd" d="M2.66122 7.98084L2.09119 6.59179L1.52441 7.98084H2.66122ZM8.1287 9.48433L8.12554 6.75542L6.91789 9.48433H6.18664L4.97584 6.75301V9.48433H3.28191L2.9619 8.70715H1.22783L0.904555 9.48433H0L1.49141 6H2.7288L4.14527 9.29894V6H5.50457L6.59452 8.3637L7.59576 6H8.98238V9.48433H8.1287ZM10.3079 8.77136V8.07794H12.1363V7.36686H10.3079V6.73324H12.3959L13.3069 7.74888L12.3555 8.77136H10.3079ZM15.9507 9.49767H14.8685L13.843 8.34393L12.7772 9.49767H9.47825V6.0125H12.828L13.8526 7.15489L14.912 6.0125H16L14.3815 7.75508L15.9507 9.49767Z" fill="#002663" /></g>;
    t2 = <defs />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ariaLabel || $[3] !== className) {
    t3 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}</svg>;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default IcoAmex16;